/*eslint-disable */
import header from '../components/header/index.vue';
import footer from '../components/footer/index.vue';
import welcome from '../components/welcome-popup/index';
export default {
  name: 'app',
  components: {
    'app-header':header,
    'app-footer':footer,
    'welcome-popup' : welcome,
  },
  props: [],
  data () {
    return {
       
    }
  },
  computed: {

  }, 
  methods: {

  }
}
